import axios from "axios";

const GetMyBooks = (auth) => {
  return axios.get("book/mybooks", {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const BuyBook = (auth, obj) => {
  return axios.post("book/buy", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const PutOnSwap = (auth, obj) => {
  return axios.put("book/putonswap", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const RemoveFromSwap = (auth, obj) => {
  return axios.put("book/removefromswap", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const ViewSwap = (auth) => {
  return axios.get("book/viewswap", {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const ViewSwapAll = () => {
  return axios.get("book/viewswapall");
};

const SearchSwapBooksWithTitleforUser = (auth, obj) => {
  return axios.post("book/search/swap/auth/title", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const SearchSwapBooksWithTitleforVisitor = (obj) => {
  return axios.post("book/search/swap/title", obj);
};
const SearchSwapBooksWithAuthorforUser = (auth, obj) => {
  return axios.post("book/search/swap/auth/author", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const SearchSwapBooksWithAuthorforVisitor = (obj) => {
  return axios.post("book/search/swap/author", obj);
};

const AcceptOffer = (auth, obj) => {
  return axios.put("book/swap", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};

export {
  GetMyBooks,
  BuyBook,
  PutOnSwap,
  RemoveFromSwap,
  ViewSwap,
  ViewSwapAll,
  AcceptOffer,
  SearchSwapBooksWithAuthorforUser,
  SearchSwapBooksWithAuthorforVisitor,
  SearchSwapBooksWithTitleforUser,
  SearchSwapBooksWithTitleforVisitor,
};
